import { Injectable } from '@angular/core';
import { TypeDureeMarche } from '../../models/TypeDureeMarche';

@Injectable({
  providedIn: 'root'
})
export class DureeService {

  constructor() {
  }

  getDuree(controls: any) {
    const duree = new TypeDureeMarche();
    let dateACompterDu = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateACompterDu';
    duree.dateACompterDu = this.combineDateAndTimestamp(
      controls.get(dateACompterDu),
      controls.get(dateACompterDu + '_timestamp')
    );
    let dateDebutPrestation = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateDebutPrestation';
    duree.dateDebutPrestation = this.combineDateAndTimestamp(
      controls.get(dateDebutPrestation),
      controls.get(dateDebutPrestation + '_timestamp')
    );
    let dateDebutTravaux = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateDebutTravaux';
    duree.dateDebutTravaux = this.combineDateAndTimestamp(
      controls.get(dateDebutTravaux),
      controls.get(dateDebutTravaux + '_timestamp')
    );
    let dateJusquau = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateJusquau';
    duree.dateJusquau = this.combineDateAndTimestamp(
      controls.get(dateJusquau),
      controls.get(dateJusquau + '_timestamp')
    );
    duree.nbJours = controls.get('_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbJours');
    duree.nbMois = controls.get('_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbMois');
    duree.txtLibre = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_txtLibre'));
    return duree;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  /**
   * Combine une date et un timestamp en format ISO 8601 (date + 'T' + time)
   * Retourne null si la date est null ou vide
   */
  private combineDateAndTimestamp(date: any, timestamp: any): string | null {
    const sanitizedDate = this.sanitizeString(date);
    const sanitizedTimestamp = this.sanitizeString(timestamp);

    // Si pas de date, retourner null (ne pas concaténer le timestamp seul)
    if (!sanitizedDate) {
      return null;
    }

    // Si pas de timestamp, retourner la date seule
    if (!sanitizedTimestamp) {
      return sanitizedDate;
    }

    // Combiner avec le séparateur 'T' pour le format ISO 8601
    return sanitizedDate + 'T' + sanitizedTimestamp;
  }
}
